import { FC } from 'react';

import s from './ContentsDescription.module.scss';
import { NativeAttrs } from './ContentsDescription.types';
import ImageArea from './ImageArea';
import TextArea from './TextArea';

export type ContentsDescriptionProps = NativeAttrs<object, HTMLDivElement>;

const ContentsDescription: FC<React.PropsWithChildren<React.PropsWithChildren<ContentsDescriptionProps>>> = ({ children, ...props }) => {
  return (
    <div className={s.description__contents} {...props}>
      {children}
    </div>
  );
};

type ContentsDescriptionComponent<P> = FC<React.PropsWithChildren<React.PropsWithChildren<P>>> & {
  TextArea: typeof TextArea;
  ImageArea: typeof ImageArea;
};

export default ContentsDescription as ContentsDescriptionComponent<ContentsDescriptionProps>;
